import { Routes, Route, Navigate } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { GoogleOAuthProvider } from '@react-oauth/google';
import '@mantine/core/styles.css';
import { shopTheme } from './theme';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ShopLayout } from './components/ShopLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ConversationsPage } from './pages/ConversationsPage';
import { JobPage } from './pages/JobPage';
import { NewRoPage } from './pages/NewRoPage';
import { SettingsPage } from './pages/SettingsPage';
import { SmsInboxPage } from './pages/SmsInboxPage';
import { SelectShopPage } from './pages/SelectShopPage';
import { applyEmbedBootstrap, EmbedNavListener } from './embed/embedBridge';

const GOOGLE_CLIENT_ID = '350978252083-0533mo14fjg8sc35a3848qpqkncjn43s.apps.googleusercontent.com';

// Apply the extension's one-time auth/config hand-off BEFORE any render so the
// token is in place before AuthProvider decides logged-in/out. No-op standalone.
applyEmbedBootstrap();

export default function ShopApp() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <MantineProvider
      theme={shopTheme}
      defaultColorScheme="dark"
      cssVariablesSelector=".haist-shop"
    >
      <div className="haist-shop" style={{ height: '100%' }}>
        <AuthProvider>
          <EmbedNavListener />
          <Routes>
            <Route path="login" element={<LoginPage />} />
            <Route
              path="select-shop"
              element={
                <ProtectedRoute>
                  <SelectShopPage />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <ShopLayout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="conversations" element={<ConversationsPage />} />
              <Route path="conversations/new" element={<NewRoPage />} />
              <Route path="conversations/:conversationId" element={<JobPage />} />
              <Route path="sms" element={<SmsInboxPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="*" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </div>
    </MantineProvider>
    </GoogleOAuthProvider>
  );
}
